var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { requireToken } from '../../../utility/general';
import { getJson, postObjectJson } from '../../../utility/request';
import { getConnectorIntuit } from '../../../http/connectors';
import Card from '../../components/card';
import CSelect from '../../components/select';
import CModalConfirm from '../../components/modal.confirm';
import Button from '../../components/button';
import IconButton from '../../components/button.icon';
import styles from '../../scss/modules/components/button.icon.module.scss';
export default (props) => {
    const token = requireToken('merchant');
    const [state, setState] = React.useState({
        'intuit': undefined,
        'confirmDelete': false,
        'intuitAccounts': null,
        'intuitAccountEdit': null,
    });
    const loadIntuit = () => __awaiter(void 0, void 0, void 0, function* () {
        setState((s) => (Object.assign(Object.assign({}, s), { 'intuit': undefined })));
        const value = yield getConnectorIntuit(token.merchant.id);
        setState((s) => (Object.assign(Object.assign({}, s), { 'intuit': value })));
    });
    const startEdit = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!state.intuit) {
            return;
        }
        const accounts = yield getJson(`/intuit/accounts/${token.merchant.id}`);
        setState((s) => {
            var _a;
            return (Object.assign(Object.assign({}, s), { 'intuitAccounts': accounts, 'intuitAccountEdit': ((_a = s.intuit) === null || _a === void 0 ? void 0 : _a.invoice_account_id) || null }));
        });
    });
    const cancelEdit = () => {
        setState((s) => (Object.assign(Object.assign({}, s), { 'intuitAccounts': null })));
    };
    const saveEdit = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!state.intuitAccounts || !state.intuitAccountEdit) {
            return;
        }
        const account = state.intuitAccounts.find((x) => x.id === state.intuitAccountEdit);
        if (!account) {
            return;
        }
        const updated = yield postObjectJson(`/intuit/config/${token.merchant.id}`, {
            'id': account.id,
            'name': account.name,
        });
        setState((s) => (Object.assign(Object.assign({}, s), { 'intuit': updated, 'intuitAccounts': null })));
    });
    const deleteIntuit = (finish) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield postObjectJson(`/intuit/delete/${token.merchant.id}`, {});
            yield loadIntuit();
            setState((s) => (Object.assign(Object.assign({}, s), { 'confirmDelete': false })));
        }
        finally {
            finish();
        }
    });
    React.useEffect(() => {
        loadIntuit();
    }, []);
    const channel = React.useMemo(() => new BroadcastChannel('INTUIT'), []);
    React.useEffect(() => {
        channel.onmessage = () => {
            loadIntuit();
        };
        return () => {
            channel.close();
        };
    }, [channel]);
    return _jsxs(_Fragment, { children: [_jsx(CModalConfirm, { title: "Disconnect Intuit/QuickBooks", action: "Disconnect", visible: state.confirmDelete, onClose: () => setState((s) => (Object.assign(Object.assign({}, s), { 'confirmDelete': false }))), onSubmit: (f) => deleteIntuit(f), children: "Are you sure you want to disconnect? Existing data will not be affected, but new actions will not flow." }), _jsx(Card, { title: "Intuit QuickBooks", children: state.intuit === undefined ? _jsx(_Fragment, { children: "Loading..." }) : state.intuit === null ? _jsx(_Fragment, { children: _jsx("a", { target: "_blank", href: `/intuit/signin/${token.merchant.id}`, className: `btn btn-sm ${styles.button} ${styles.primary} w-100`, children: "Sign In to Intuit/QuickBooks" }) }) : !!state.intuitAccounts ? _jsx(_Fragment, { children: _jsxs("div", { className: "d-flex", children: [_jsx(CSelect, { inline: true, value: state.intuitAccountEdit, onChange: (x) => setState((s) => (Object.assign(Object.assign({}, s), { 'intuitAccountEdit': x }))), items: state.intuitAccounts, valuef: (x) => x.id, titlef: (x) => x.name, children: "Invoices Account" }), _jsx(IconButton, { color: "success", title: "Save", onClick: saveEdit, children: "save" }), _jsx(IconButton, { color: "secondary", title: "Close", onClick: cancelEdit, children: "close" })] }) }) : _jsx(_Fragment, { children: _jsx(Button, { color: "danger", w100: true, mt: 2, onClick: () => setState((s) => (Object.assign(Object.assign({}, s), { 'confirmDelete': true }))), children: "Disconnect Intuit/QuickBooks" }) }) })] });
};
